// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T3Be","content":"styles_content__3Ipov","tableWrap":"styles_tableWrap__3GIfE"};